<template>
	<div style="float: left;overflow: hidden;">
		<div style="background: white;width: 249px;height:280px;padding:20px;border-radius: 5px;">
			<div class="ripple-icon hover-style2 " style="margin:20px auto;">
				<i class="flaticon-discuss"></i>
			</div>
			<h5 style="text-align: center; margin-top: 20px;font-weight: 800;">欢迎您</h5>
			<div style="text-align: center; 0;font-weight: 800;">{{phone}}</div>
			<a class="col-xl-12 text-center">
				<button type="submit" class="vs-btn style2"
					style="border-radius: 5px;height:35px;width: 80%;padding: 0;margin: 15px auto;" @click="log_out">退出</button>
			</a>
		</div>
		<div style="background: white;width: 249px;margin-top: 30px;border-radius: 5px;">
			<el-row class="tac" style="width: 100%;border-radius: 5px;">
				<el-col :span="12">
					<el-menu :default-active="selected_page" class="el-menu-vertical-demo" :default-openeds="openeds">
						<el-submenu index="my_infor">
							<template slot="title">
								<i class="el-icon-menu"></i>
								<span>个人中心</span>
							</template>
							<el-menu-item-group>
								<!-- <a href="#/user/index"><el-menu-item index="1-1" style="color:#8a8a8a">我的首页</el-menu-item></a> -->
								<a href="#/user/notice">
									<el-menu-item index="1-1">消息通知</el-menu-item>
								</a>
								<a href="#/user/infor">
									<el-menu-item index="1-2" >个人信息</el-menu-item>
								</a>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="online_work">
							<template slot="title">
								<i class="el-icon-menu"></i>
								<span>在线委托单</span>
							</template>
							<el-menu-item-group>
								<a href="#/user/kjcx">
									<el-menu-item index="2-1" >科技查新</el-menu-item>
								</a>
								<a href="#/user/kjcy">
									<el-menu-item index="2-2" >科技查引</el-menu-item>
								</a>
								<a href="#/user/SCI">
									<el-menu-item index="2-3" >SCI查收</el-menu-item>
								</a>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="order_center">
							<template slot="title">
								<i class="el-icon-menu"></i>
								<span>订单中心</span>
							</template>
							<el-menu-item-group>
								<a href="#/user/order">
									<el-menu-item index="3-1">我的订单</el-menu-item>
								</a>
							</el-menu-item-group>
						</el-submenu>
						<el-submenu index="invoice_manage">
							<template slot="title">
								<i class="el-icon-menu"></i>
								<span>发票管理</span>
							</template>
							<el-menu-item-group>
								<a href="#/user/invoice">
									<el-menu-item index="4-1" >开具发票</el-menu-item>
								</a>
								<a href="#/user/invoice_infor">
									<el-menu-item index="4-2" >发票抬头</el-menu-item>
								</a>
								<a href="#/user/invoice_list">
									<el-menu-item index="4-3" >开票记录</el-menu-item>
								</a>
							</el-menu-item-group>
						</el-submenu>
					</el-menu>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
	export default {
		name: "rosidebar",
		props: ['selected_page'],
		data: function() {
			return {
				phone: window.localStorage.getItem('phone'),
				isCollapse: true,
				openeds: ['my_infor', 'order_center', 'online_work', 'invoice_manage']
			};
		},
		created:function(){
				console.log('created')
				// debugger
				
				if(window.localStorage.getItem('user_id')=='false'||window.localStorage.getItem('user_id')==null){
					this.$router.push("/pages/login")
				}
		},
		methods: {
			log_out(){
				window.localStorage.setItem('user_id',false)
				window.localStorage.setItem('phone',false)
                                window.localStorage.setItem('session_id', false)
				this.$router.push("/pages/login")
				// location.reload();
			},
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			}
		}
	};
</script>

<style>
	@import url("../../static/css/css2.css");
	@import url("../../static/css/app.min.css");
	@import url("../../static/css/fontawesome.min.css");
	@import url("../../static/css/animate.min.css");
	@import url("../../static/css/style.css");

	.ro-header-btn {
		font-size: 12px;
		text-align: center;
		padding: 3px 10px;
		border-radius: 5px;
		border: 1px solid white;
	}

	.vs-btn.style3:before,
	.vs-btn.style2:before {
		position: unset;
	}

	.el-col-12 {
		width: 100% !important;
		text-align: left;
	}

	.el-menu {
		border-radius: 5px;
	}

	.el-menu-item.is-active {
		color: #409eff;
		background: #ecf5ff;
	}
</style>
